module.exports = __webpack_public_path__ + "img/etusivu3.9d878c23.jpg";